import React from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'

import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import ContextSubscriber from '@aytm/lib/common/components/decorators/ContextSubscriber'
import ManagedRenderComponent from '@aytm/lib/common/components/ManagedRenderComponent'

import { EMAIL_REGEX } from '@aytm/app/lib/regex'
import { reportStatePath, updateListState } from '@aytm/app/stats/page/sidebar/reports/actions'

// components
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'

// styles
import style from '@aytm/app/stats/page/sidebar/reports/styles/ReportPopup.module.scss'

const EMAILS_MAX = 10

// <Component>
// eslint-disable-next-line no-class-assign
class ReportPopupSharing extends ManagedRenderComponent {
  static propTypes = {
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func
  }
  static updateOnProps(nextProps, prevProps) {
    return nextProps.state != prevProps.state || nextProps.model != prevProps.model
  }

  constructor(...args) {
    super(...args)
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onChange = this.onChange.bind(this)
    this.checkEmails = this.checkEmails.bind(this)
    this.sendEmails = this.sendEmails.bind(this)
    this.tickToHideEmails = this.tickToHideEmails.bind(this)
  }

  state = {
    focused: null,
    emails: '',
    emailsReady: true,
    emailsSuccess: false,
    emailsError: false,
    emailsSentCount: 0,
    emailsInvalid: '',
    emailsChanged: false
  }

  onFocus(val) {
    const { onFocus } = this.props
    'function' == typeof onFocus && onFocus()

    this.setState({ focused: val })
  }

  onBlur() {
    const { onBlur } = this.props
    'function' == typeof onBlur && onBlur()

    this.setState({ focused: null })
  }

  onChange(event) {
    const { onChange } = this.props
    'function' == typeof onChange && onChange()

    this.setState({
      emails: event.target.value,
      emailsReady: 0 < event.target.value.length,
      emailsSuccess: false,
      emailsError: false,
      emailsSentCount: 0,
      emailsInvalid: '',
      emailsChanged: true
    })
  }

  checkEmails() {
    const emails = this.state.emails
      .replace(/[\s,:;]/g, ' ')
      .split(' ')
      .map(v => v.trim())
      .filter(v => 0 < v.length)
    const valid = 0 < emails.length && emails.length <= EMAILS_MAX && emails.every(v => null !== v.match(EMAIL_REGEX))
    return valid
  }

  sendEmails() {
    const { url, model, listState, actions } = this.props
    if (!this.checkEmails()) this.setState({ emailsReady: false })
    else {
      const newListState = updateListState({
        updates: [{ path: reportStatePath(model.get('id'), 'process'), value: 'send' }],
        listState: listState,
        actions
      })
      railsPostFetch(url, {
        body: JSON.stringify({ do: 'email', id: model.get('id'), emails: this.state.emails })
      })
        .then(response => response.json())
        .then(data => {
          updateListState({
            updates: [{ path: reportStatePath(model.get('id'), 'process'), value: null }],
            listState: newListState,
            actions
          })
          if (data.status) {
            this.setState({
              emailsSuccess: true,
              emailsError: false,
              emailsSentCount: data.sent_count || 0 < this.state.emails.length,
              emailsInvalid: data.invalid_emails ? data.invalid_emails.reduce((p, c) => p + ', ' + c) : '',
              emailsChanged: false
            })
          } else {
            this.setState({ emailsError: true })
          }
          this.tickToHideEmails()
        })
        .catch(() => {
          this.tickToHideEmails()

          updateListState({
            updates: [{ path: reportStatePath(model.get('id'), 'process'), value: null }],
            listState: newListState,
            actions
          })
        })
    }
  }

  tickToHideEmails() {
    setTimeout(() => {
      this.setState({ emailsSuccess: false, emailsError: false, emailsSentCount: 0, emailsInvalid: '' })
    }, 15000)
  }

  render() {
    const { state, model, virtualReportsIds, isSurveyGuest, isSurveyViewer } = this.props
    const { emails, focused, emailsReady, emailsSuccess, emailsError, emailsSentCount, emailsInvalid, emailsChanged } =
      this.state
    const shareLinkExist = model.get('shareLink') && 0 < model.get('shareLink').length
    const isProcessing = state.has('process')
    const isDisabled =
      !emails.length || !shareLinkExist || !emailsReady || isProcessing || isSurveyGuest || isSurveyViewer

    return (
      <div>
        <div className={`${style['content-row']} p-fluid`}>
          <div className={`${style['content-row-column']} ${style['content-row-column-title']}`}>
            REPORT SHARING OPTIONS
          </div>
        </div>
        <div className={`${style['content-row']} p-fluid`}>
          <div className={`${style['content-row-column']} ${style['content-row-column-note']}`}>
            SHARE REPORT BY EMAIL (Enter up to 10 emails below)
          </div>
        </div>
        <div
          className={`${style['content-row']}${'email' == focused ? ' ' + style['content-row-focused'] : ''} p-fluid`}
        >
          <div className={`${style['content-row-column']} ${style['content-row-column-icon']}`}>
            <i className="icon-aytmfd-email" />
          </div>
          <div className={`${style['content-row-column']} ${style['content-row-column-input']}`}>
            <InputText
              className={0 < emails.length && emailsChanged && !emailsReady ? 'p-invalid' : ''}
              value={emails}
              disabled={virtualReportsIds.includes(model.get('type')) || isSurveyGuest || isSurveyViewer}
              onChange={
                virtualReportsIds.includes(model.get('type')) || isSurveyGuest || isSurveyViewer ? null : this.onChange
              }
              onFocus={() => {
                this.onFocus('email')
              }}
              onBlur={this.onBlur}
            />
          </div>
          <div className={`${style['content-row-column']} ${style['content-row-column-button']}`}>
            <Button
              className="p-button-stat"
              label="SEND"
              loading={isProcessing && 'send' == state.get('process')}
              disabled={virtualReportsIds.includes(model.get('type')) || isDisabled}
              onClick={virtualReportsIds.includes(model.get('type')) || isDisabled ? null : this.sendEmails}
            />
          </div>
        </div>
        {emailsSuccess || emailsError ? (
          <div className={`${style['content-row']} p-fluid`}>
            {emailsSuccess ? (
              <div
                className={`${style['content-row-column']} ${style['content-row-column-text']} ${style['content-row-column-success']}`}
              >
                {0 == emailsSentCount ? 'No emails sent' : null}
                {1 == emailsSentCount ? 'Email was sent' : null}
                {1 < emailsSentCount ? 'Emails were sent' : null}
                {'' != emailsInvalid && 0 < emailsSentCount ? ', except' : null}
                {'' != emailsInvalid && 0 < emailsSentCount ? (
                  <span className={style['content-row-column-error']}>{emailsInvalid}</span>
                ) : null}
              </div>
            ) : null}
            {emailsError ? (
              <div
                className={`${style['content-row-column']} ${style['content-row-column-text']} ${style['content-row-column-error']}`}
              >
                Something went wrong, please try again later
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    )
  }
}

ReportPopupSharing = ContextSubscriber(
  {
    name: 'report',
    contextTypes: {
      state: PropTypes.instanceOf(Map).isRequired,
      model: PropTypes.instanceOf(Map).isRequired
    },
    mapToProps(values) {
      return {
        state: values.state,
        model: values.model
      }
    }
  },
  {
    name: 'reportList',
    contextTypes: {
      url: PropTypes.string.isRequired,
      state: PropTypes.instanceOf(Map).isRequired,
      actions: PropTypes.object.isRequired,
      virtualReportsIds: PropTypes.array.isRequired,
      isSurveyGuest: PropTypes.bool,
      isSurveyViewer: PropTypes.bool
    },
    mapToProps(values) {
      return {
        url: values.url,
        listState: values.state,
        actions: values.actions,
        virtualReportsIds: values.virtualReportsIds,
        isSurveyGuest: values.isSurveyGuest,
        isSurveyViewer: values.isSurveyViewer
      }
    }
  }
)(ReportPopupSharing)

export default ReportPopupSharing
